module.exports = __webpack_public_path__ + "static/hyperv_22.b242af57.jpg";